import { getDynamicHighlightBoxTemplate, getDynamicHighlightBoxWithBorderTemplate } from "../../shortcodes/templates";
import { getShortcodeWrapper, addShortcodeToEditor } from "../../shortodeAddition";

const dynamicTextHighlightConfig = (tinymce, uuid, shortcodeOnClick) => {
  const boxWithBorderConfig = {
    title: "Text highlight box",
    body: {
      type: "panel",
      items: [
        {
          type: "colorinput",
          name: "bgColor",
          label: "Background color",
        },
        {
          type: "colorinput",
          name: "borderColor",
          label: "Border color",
        },
      ],
    },
    initialData: {
      bgColor: "#F8F9FA",
      borderColor: "#394AE1",
    },
    buttons: [
      {
        type: "custom",
        name: "back",
        text: "Previous",
      },
      {
        type: "submit",
        name: "submit",
        text: "Add",
        primary: true,
      },
    ],
    onAction: (api, details) => {
      if (details.name === "back") {
        api.redial(mainHighlightBoxConfig);
      }
    },
    onSubmit: api => {
      const data = api.getData();
      const parentElement = tinymce.activeEditor.selection.getNode().nodeName.toLowerCase();
      const templateToAdd = getDynamicHighlightBoxWithBorderTemplate({
        bgColor: data.bgColor,
        borderColor: data.borderColor,
      });

      const shortcodeWrapper = getShortcodeWrapper(uuid, shortcodeOnClick, templateToAdd);
      addShortcodeToEditor(shortcodeWrapper, uuid, parentElement, api);
      api.close();
    },
  };
  const boxWithoutBorderConfig = {
    title: "Text highlight box",
    body: {
      type: "panel",
      items: [
        {
          type: "colorinput",
          name: "color",
          label: "Background color",
        },
      ],
    },
    initialData: {
      color: "#F8F9FA",
    },
    buttons: [
      {
        type: "custom",
        name: "back",
        text: "Previous",
      },
      {
        type: "submit",
        name: "submit",
        text: "Add",
        primary: true,
      },
    ],
    onAction: (api, details) => {
      if (details.name === "back") {
        api.redial(mainHighlightBoxConfig);
      }
    },
    onSubmit: api => {
      const data = api.getData();
      const parentElement = tinymce.activeEditor.selection.getNode().nodeName.toLowerCase();
      const templateToAdd = getDynamicHighlightBoxTemplate(data.color);

      const shortcodeWrapper = getShortcodeWrapper(uuid, shortcodeOnClick, templateToAdd);
      addShortcodeToEditor(shortcodeWrapper, uuid, parentElement, api);
      api.close();
    },
  };
  const mainHighlightBoxConfig = {
    title: "Text highlight box",
    body: {
      type: "panel",
      items: [
        {
          type: "selectbox",
          name: "type",
          label: "Type",
          items: [
            { value: "1", text: "With border" },
            { value: "2", text: "Without border" },
          ],
        },
      ],
    },
    buttons: [
      {
        type: "cancel",
        name: "close",
        text: "Cancel",
      },
      {
        type: "submit",
        name: "submit",
        text: "Next",
        primary: true,
      },
    ],
    onSubmit: api => {
      const data = api.getData();
      if (data.type === "1") {
        api.redial(boxWithBorderConfig);
      } else if (data.type === "2") {
        api.redial(boxWithoutBorderConfig);
      }
    },
  };

  tinymce.activeEditor.windowManager.open(mainHighlightBoxConfig);
};

export { dynamicTextHighlightConfig };
